import { moduleProviderFactory, routeProvider, menuProvider, storeProvider } from 'core/providers';
import { getModulesInfo } from 'core/utils';

class BaasicBootstrap {
	run(context) {
		const { common, platform, application } = moduleProviderFactory;

		const modules = [...common.getModules()];

		const { routes, storeFactories } = getModulesInfo(modules);

		const appModuleInfo = getModulesInfo(application.getModules());
		const platformModuleInfo = getModulesInfo(platform.getModules());

		context.rootStore.initialize = {
			routes: (r, ctx = {}) => {
				routeProvider.initialize(r, { ...ctx, ...context });
			},
			stores: (sf, ctx = {}) => {
				storeProvider.initialize(sf, { ...ctx, ...context });
			},
			menus: (m, ctx = {}) => {
				menuProvider.initialize(m, { ...ctx, ...context });
			},
		};

		context.rootStore.initialize.routes([...routes, ...appModuleInfo.routes, ...platformModuleInfo.routes]);
		context.rootStore.initialize.stores(storeFactories, context);
	}
}

export default new BaasicBootstrap();
